import { useQuery } from "@tanstack/react-query";
import { getUsersByIds } from "../service/user";

export function useUsersByIds(userIds: number[]) {
  return useQuery({
    queryKey: ["users-by-ids", userIds],
    queryFn: async () => {
      if (userIds.length === 0) return [];

      const res = await getUsersByIds(userIds);
      return res.users;
    },
    enabled: userIds.length > 0,
    staleTime: 1000 * 60 * 10 // 10 min
  });
}
